import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteAcademicTerm as apiForceDelete } from "../../api/apiAcademicTerms";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteAcademicTerm() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: forceDeleteAcademicTerm, isPending: isForceDelete } = useMutation({
        mutationFn: (id) => apiForceDelete(id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["academicTerms"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { forceDeleteAcademicTerm, isForceDelete };
}
